/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VariablesReferentialDto
 */
export interface VariablesReferentialDto {
    /**
     * Unique identifier for the referential variable
     * @type {string}
     * @memberof VariablesReferentialDto
     */
    idReferentialVariable: string;
    /**
     * Float value of the variable
     * @type {number}
     * @memberof VariablesReferentialDto
     */
    value: number;
}

/**
 * Check if a given object implements the VariablesReferentialDto interface.
 */
export function instanceOfVariablesReferentialDto(value: object): value is VariablesReferentialDto {
    if (!('idReferentialVariable' in value) || value['idReferentialVariable'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function VariablesReferentialDtoFromJSON(json: any): VariablesReferentialDto {
    return VariablesReferentialDtoFromJSONTyped(json, false);
}

export function VariablesReferentialDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VariablesReferentialDto {
    if (json == null) {
        return json;
    }
    return {
        
        'idReferentialVariable': json['idReferentialVariable'],
        'value': json['value'],
    };
}

export function VariablesReferentialDtoToJSON(json: any): VariablesReferentialDto {
    return VariablesReferentialDtoToJSONTyped(json, false);
}

export function VariablesReferentialDtoToJSONTyped(value?: VariablesReferentialDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idReferentialVariable': value['idReferentialVariable'],
        'value': value['value'],
    };
}

